import React, { useEffect, useRef, useState } from 'react'
import { copyText } from './validation';

function CopyListCell({
  value,
  maxLength = 15,
}) {
  const [showTip, setShowTip] = useState(false);
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef();

  const short =
    value.length > maxLength ? value.slice(0, maxLength) + '…' : value;

  const handleCopy = async () => {
    await copyText(value);
    setCopied(true);
    setShowTip(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setCopied(false);
      setShowTip(false);
    }, 1500);
  };

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return (
    <div
      className="relative inline-block cursor-pointer group"
      onMouseEnter={() => !copied && setShowTip(true)}
      onMouseLeave={() => !copied && setShowTip(false)}
      onClick={handleCopy}
    >
      <span className="text-blue-600 hover:underline">{short}</span>

      {/* Tooltip */}
      <div
        className={`
          absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1
          w-max max-w-xs px-2 py-1 text-xs text-white bg-gray-800 rounded
          whitespace-pre-wrap z-10 transition-opacity duration-200
          ${showTip ? 'opacity-100' : 'opacity-0 pointer-events-none'}
        `}
      >
        {copied ? 'Copied!' : ''}
      </div>
    </div>
  );
}
export default CopyListCell
